import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutWrapper"] */ "/home/runner/work/monorepo/monorepo/frontend/src/components/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComposeProvider"] */ "/home/runner/work/monorepo/monorepo/frontend/src/context/ComposeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OmniBoxProvider"] */ "/home/runner/work/monorepo/monorepo/frontend/src/context/OmniBoxContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoProvider"] */ "/home/runner/work/monorepo/monorepo/frontend/src/context/UserInfoContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/frontend/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/frontend/src/styles/logo.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/runner/work/monorepo/monorepo/frontend/src/theme/ThemeContext.tsx");
